import { DeaBirthdaysListingDialogComponent } from 'src/app/components/dea-pack/dea-birthdays-listing-dialog/dea-birthdays-listing-dialog.component';
import { DeaUserConfirmDialogComponent } from 'src/app/components/dea-pack/dea-user-confirm-dialog/dea-user-confirm-dialog.component';
import { DeaWelcomeDialogComponent } from 'src/app/components/dea-pack/dea-welcome-dialog/dea-welcome-dialog.component';
import { ClientStorageService } from 'src/app/services/client-storage.service';
import { DeaDropdownMenuEventData } from 'src/app/constants/interfaces';
import { StorageKeys } from 'src/app/constants/storege-keys';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Headquarter } from 'src/app/models/headquarter';
import { AppPaths } from 'src/app/constants/app-paths';
import { User } from 'src/app/models/user/user.model';
import { MatDialog } from '@angular/material/dialog';
import { API } from 'src/app/constants/api';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  protected ringIconUrl = API.deAmicisRingIcon();
  protected avatarUrl = API.thumbnail(1);
  protected env = environment;

  protected headquarters: string[] = Headquarter.getFrontendHeadqarters();
  protected selectedHeadquarter: string = Headquarter.MILANO.frontend;
  protected sectionsConfig$ = this._authService.sectionsState$;
  protected usersBirthdaysListing: User[] = [];

  constructor(
    private _router: Router,
    private _dialog: MatDialog,
    private _authService: AuthService,
    private _userService: UserService,
    private _clientStorageService: ClientStorageService
  ) {}

  ngOnInit(): void {
    const session = this._clientStorageService.getSessionCheck();
    if (!session) this._router.navigateByUrl(AppPaths.SESSION);

    if (session && !this._clientStorageService.getStatusWelcomeMessage()) {
      const errorDialogRef = this._dialog.open(DeaWelcomeDialogComponent, {
        maxWidth: '500px',
        minWidth: '500px',
        autoFocus: false,
        restoreFocus: false,
      });
      errorDialogRef
        .afterClosed()
        .subscribe(() =>
          this._clientStorageService.setStatusWelcomeMessage(true)
        );
    }

    this.selectedHeadquarter = this._clientStorageService.setHeadquarter(
      localStorage.getItem(StorageKeys.HEADQUARTER)
    );
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    if (this._authService.sectionsState$.getValue().retrieved === false) {
      setTimeout(() => this._authService.initSections(), 250);
    }
    setTimeout(() => {
      this.getBirthdaysListing({ date: `${year}-${month}-${day}` });
    }, 1500);
  }

  onHeadquarterChange(eventData: DeaDropdownMenuEventData) {
    if (eventData.id === 'dropdownInputDashboardHeadquarter') {
      this.selectedHeadquarter = this._clientStorageService.setHeadquarter(
        Headquarter.fromString(this.headquarters[eventData.index])?.backend ??
          Headquarter.MILANO.backend
      );
      window.location.reload();
    }
  }

  openBirthdaysListing() {
    this._dialog
      .open(DeaBirthdaysListingDialogComponent, {
        maxWidth: '500px',
        minWidth: '500px',
        data: {
          users: this.usersBirthdaysListing,
        },
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe((dialogResult: any) => {
        if (dialogResult != undefined) {
          this._router.navigateByUrl(AppPaths.UTENTE + `/${dialogResult}`);
        }
      });
  }

  logoutConfirmDialog() {
    const confirmDialogRef = this._dialog.open(DeaUserConfirmDialogComponent, {
      maxWidth: '400px',
      minWidth: '380px',
      data: {
        message: 'Vuoi effettuare il logout?',
      },
      autoFocus: false,
      restoreFocus: false,
    });

    confirmDialogRef.afterClosed().subscribe((dialogResult: any) => {
      if (dialogResult === true) this._router.navigateByUrl(AppPaths.LOGOUT);
    });
  }

  getBirthdaysListing(p?: { date?: string }) {
    this._userService.getBirthdaysListing(p).subscribe({
      error: (error) => console.error('getBirthdaysListing Error: ', error),
      next: (data) => {
        this.usersBirthdaysListing = data?.data?.map(
          (json: any) => new User(json)
        );
      },
    });
  }
}
